import React from 'react';
import ReactPlayer from 'react-player';
import './styles.scss';

const VideoPlayer = (props) => {
  return (
    <div className="player-wrapper">
      <ReactPlayer
        className="react-player"
        width={props.width}
        height={props.height}
        controls
        {...props}
      />
    </div>
  );
};

export default VideoPlayer;

VideoPlayer.defaultProps = {
  height: '100%',
  width: '100%',
};
